module.exports = __webpack_public_path__ + "static/media/ajax-Loader.ad658775.gif";